<template>
  <section class="relative slider-button" v-if="!!items.length">
    <button
      class="slick-button slick-button-prev responsibility"
      :class="{'slick-button-green': currentPage < items.length - slidesPerPage, 'hidden-button' : items.length < 5}"
      @click="showNext"
    >
      <i class="material-icons p15 pointer">keyboard_arrow_right</i>
    </button>
    <VueSlickCarousel
      v-bind="config"
      ref="slick"
      class="category-sliders-order-history"
      @afterChange="setMuted"
    >
      <div v-for="(item, index) in items" class="relative mb20 between-xs row center-xs px15" :key="index">
        <order-slider-product :product="item" :orderId="orderId" :show-add-to-cart="showAddToCart" />
      </div>
    </VueSlickCarousel>
    <button class="slick-button slick-button-next responsibility"
            :class="{ 'slick-button-green': currentPage > 0,'hidden-button' : items.length < 5 }"
            @click="showPrevious"
    >
      <i class="material-icons p15 pointer">keyboard_arrow_left</i>
    </button>
  </section>
  <section class="relative slider-button" v-else>
    <VueSlickCarousel
      v-bind="config"
      ref="slick"
      class="category-sliders-order-history"
      @afterChange="setMuted"
    >
      <div v-for="item in slidesPerPage" :key="item" class="relative mb20 between-xs row center-xs px15">
        <order-slider-product-skeleton />
      </div>
    </VueSlickCarousel>
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

const OrderSliderProduct = () => import(/* webpackChunkName: "vsf-order-slider-product" */ 'theme/components/core/blocks/MyAccount/OrderSliderProduct');
const OrderSliderProductSkeleton = () => import(/* webpackChunkName: "vsf-order-slider-product-skeleton" */ 'theme/components/core/blocks/MyAccount/OrderSliderProductSkeleton.vue');

export default {
  name: 'OrderSlider',
  props: {
    config: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      default: () => []
    },
    slidesPage: {
      type: Object,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    showAddToCart: {
      type: Boolean,
      default: false
    }
  },
  components: {
    OrderSliderProductSkeleton,
    VueSlickCarousel,
    OrderSliderProduct
  },
  data () {
    return {
      currentPage: 0,
      maxPage: 0
    }
  },
  methods: {
    showNext () {
      this.$refs.slick.next();
    },
    showPrevious () {
      this.$refs.slick.prev();
    },
    setMuted (currentPage) {
      if (currentPage > this.maxPage) {
        this.maxPage = currentPage;
      }
      this.currentPage = currentPage
    }
  },
  computed: {
    slidesPerPage() {
      if (window.innerWidth < 480) {
        return this.slidesPage.mobileS;
      }
      if (window.innerWidth < 600) {
        return this.slidesPage.mobileM;
      }
      if (window.innerWidth < 1024) {
        return this.slidesPage.tablet;
      }
      return this.slidesPage.desktop;
    }
  }
}
</script>

<style lang="scss" scoped>

  .hidden-button{
    visibility: hidden;
    @media (max-width: 500px) {
      visibility: visible;
    }
  }

  .slider-button{
    overflow: hidden;
  }

  .image-product{
    width: 100%;
    margin-bottom: 10px;
  }
  .slick-button {
    z-index: 1;
    border: 0px;
    border-radius: 50%;
    transition: opacity 200ms linear 0s;
    text-align: left;
    line-height: 1;
    color: rgb(255, 255, 255);
    width: 55px;
    height: 55px;
    padding: 0;

    i{
      font-size: 28px;
      padding: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .slick-button-green {
    background-color: rgba(0, 0, 0, 0.9);
    box-shadow: rgba(0, 0, 0, 0.26) 0px 1px 2px 0px, rgba(0, 0, 0, 0.16) 0px 1px 4px 0px;
  }

  .slick-button-prev {
    position: absolute;
    right: -25px;
    top: 50%;
    transform: translateY(-50%);
    i{
      left: 5px;
    }
  }

  .slick-button-next {
    position: absolute;
    left: -25px;
    top: 50%;
    transform: translateY(-50%);
    i{
      right: 5px;
    }
  }

</style>

<style lang="scss">
  .category-sliders-order-history {
    width: 100%;
    overflow: hidden;
    .slick-track{
      display: flex;
    }
  }
</style>
